import { useMutation } from '@tanstack/react-query'
import { apiClient } from 'api/apiClient/apiClient'
import { useTranslation } from 'react-i18next'
import alertStore from 'store/alert/alert'
import type { AutomaticSettingRun, TriggerAutomaticSettingsRunParams } from './automaticSettingRuns.types'

/** Queues a run of every enabled automatic setting rule of a system over the given window. */
export function useTriggerAutomaticSettingsRunMutation() {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: (data: TriggerAutomaticSettingsRunParams) =>
      apiClient<AutomaticSettingRun>(`automatic_settings/runs/create`, { data }),
    onSuccess: () => {
      alertStore.success(t(`Automatic settings run started`))
    },
    onError: () => {
      alertStore.error(t(`Failed to start automatic settings run`))
    },
  })
}
